<template>
    <div>
        <app-sub-title text="Filtros" />
        <div class="d-flex align-items-center">
            <div class="px-2" v-if="itemTypes">
                <app-form-select-input
                    placeholder="Seleccione tipo herramienta"
                    v-model="filters.type"
                    :options="itemTypes"
                />
            </div>
            <div class="px-2">
                <app-form-text-input 
                    v-model="filters.name"
                    placeholder="Nombre"
                />
            </div>
            <div class="px-2">
                <app-form-text-input 
                    v-model="filters.slug"
                    placeholder="Slug"
                />
            </div>
            <div class="px-2">
                <b-button variant="primary" @click="$emit('filter', filters)"><i class="fa fa-filter"></i></b-button>
            </div>
            <div class="px-2">
                <b-button variant="secondary" @click="clearFilters"><i class="fa fa-times-circle"></i></b-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        itemTypes: {
            type: Array
        }
    },
    data(){
        return {
            filters: {
                name: '',
                slug: '',
                type: ''
            }
        }
    },
    methods: {
        clearFilters(){
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        }
    }
}
</script>

